import React from 'react'

function WhyChooseUs() {
  return (
    <div>WhyChooseUs</div>
  )
}

export default WhyChooseUs